import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useUser } from "../../../context/UserContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useConfig } from "../../../context/AppConfigContext";
import api from "../../../services/api";
import "./AddUserSC.css"
import Multiselect from "multiselect-react-dropdown";
import { useBanner } from "../../../context/BannerContext";
import Alert from "../../HtmlElements/Alert";

export default function AddUserSC({ onBack, edit_user_id, account_list }) {
  const navigate = useNavigate();
  const { userId } = useParams();
  const { appConfig } = useConfig();

  const { user } = useUser();
  const showBanner = useBanner();
  const [loader4UpdatingUser, setLoader4UpdatingUser] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const passwordLength = 12;
  const useSymbols = true;
  const useNumbers = true;
  const useLowerCase = true;
  const useUpperCase = true;

  const countryOptions = appConfig?.country_options || [];

  const [isEmailEditable, setIsEmailEditable] = useState(false);
  const [isPasswordEditable, setIsPasswordEditable] = useState(false);
  const [loader, setLoader] = useState(false);

  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [selectedAssignedAccounts, setSelectedAssignedAccounts] = useState([]);
  const resetToEmptyFormObj = {
    firstname :"",
    lastname: "",
    email: "",
    password: "",
    confirm_password: "",
    title: "",
    designation: "",
    company_id: "",
    company_name: "",
    country: "",
    assigned_accounts: []
  }
  const [formData, setFormData] = useState(resetToEmptyFormObj);

  useEffect(() => {
    const fetchUserData = async(userId) => {
        const filterData = {'id': userId }
        const response  = await api.get('/users/get_users_list', { "params": filterData });
        const user = response?.data?.result?.list[0] || {}
        setFormData({
            firstname: user?.firstname || "",
            lastname: user?.lastname || "",
            email: user?.email || "",
            password: "",
            confirm_password: "",
            title: user?.title || "",
            designation: user?.designation || "",
            country: user?.country || "",
            assigned_accounts: user?.assigned_accounts || []
        });

        // Get/Set Default selected accounts for user
        const getselectedAccountsObjects = (assigned_accounts) => {
        return account_list.filter(account => assigned_accounts.includes(account.account_code));
        };
        const selectedAssignedAccounts = getselectedAccountsObjects(user?.assigned_accounts || []);
        console.log("selectedAssignedAccounts : ", selectedAssignedAccounts)
          
        setSelectedAssignedAccounts(selectedAssignedAccounts);
        // End: Get/Set Default selected accounts for user
    }
    if(edit_user_id){
        fetchUserData(edit_user_id)
    }else{
        setFormData(resetToEmptyFormObj)
    }
    setErrors({
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        confirm_password: '',
        title: '',
        designation: '',
        assigned_accounts: ''
    })
  }, [edit_user_id])

  const handleChangeAccountsSelect = (assigned_accounts) => {
    const selectedVals = assigned_accounts.map((account) => {
      return account?.account_code
    });
    setFormData({ ...formData, assigned_accounts: selectedVals});
  }

  const handleRemoveAccountsSelect = (selectedList) => {
    const selectedIds = selectedList.map(item => item.account_code);
    setFormData({
      ...formData,
      assigned_accounts: selectedIds
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear the error for the current field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
    // console.log(formData);
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.firstname) {
      newErrors.firstname = "First Name is required";
    } else if (
      /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.firstname)
    ) {
      newErrors.firstname = "Special characters are not allowed in First Name";
    }

    if (!formData.lastname) {
      newErrors.lastname = "Last Name is required";
    } else if (
      /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.lastname)
    ) {
      newErrors.lastname = "Special characters are not allowed in Last Name";
    }

    if (!formData.email) {
        newErrors.email = 'Email address is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = 'Please enter a valid email address';
    }

    if (!edit_user_id) {
      // New user - password is required
      const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;
      
      if (!formData.password) {
        newErrors.password = 'Password is required';
      } else if (!formData.password.match(regex)) {
        newErrors.password = 'Password must be at least one uppercase, one lowercase, one special character, and one number!';
      }
    
      if (!formData.confirm_password) {
        newErrors.confirm_password = 'Confirm Password is required';
      } else if (formData.password !== formData.confirm_password) {
        newErrors.confirm_password = 'Passwords do not match';
      }
    } else {
      // Existing user - password is optional
      if (formData.password) {
        const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;
        
        if (!formData.password.match(regex)) {
          newErrors.password = 'Password must be at least one uppercase, one lowercase, one special character, and one number!';
        }

        if (!formData.confirm_password) {
          newErrors.confirm_password = 'Confirm Password is required';
        }
    
        if (formData?.confirm_password?.trim() !== "" && formData.password !== formData.confirm_password) {
          newErrors.confirm_password = 'Passwords do not match';
        }
      }
    }

    if (
      formData.designation &&
      /[~`!@#$%\^&*()+=\-\[\]\\';,/{}|\\":<>\?]/g.test(formData.designation)
    ) {
      newErrors.designation =
        "Special characters are not allowed in Designation";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    const formattedData = {
      firstname: formData.firstname,
      lastname: formData.lastname,
      email: formData.email,
      password: formData.password,
      confirm_password: formData.confirm_password,
      title: formData.title,
      designation: formData.designation,
      company_id: user.company_id,
      company_name: user.company_name,
      country: formData.country,
      assigned_accounts: formData?.assigned_accounts || []
    };

    setLoader4UpdatingUser(true);

    try {
      // if(userId){
      //   formattedData.id = userId;
      //   delete(formattedData.password)
      // }

      if(edit_user_id){
        formattedData.id = edit_user_id;
      }

      if (!formattedData.password) {
        delete formattedData.password;
        delete formattedData.confirm_password;
      }

      const response = await api.post("/users/add_user", formattedData);
      if (response.data.status === 201 || response.data.status === 200) {
        
        var message = "User created successfully..!"
        if(edit_user_id){
          message = "User updated successfully..!"
        }
        showBanner({
          message: message,
          title: "Alert",
          type: "success",
          duration: 10000,
        });

        onBack()
        
      } else {
        setApiError(
          response.data.result.message ||
            "An error occurred while saving the user."
        );
      }
    } catch (error) {
      var error_Msg =
        error.response?.data?.message ||
        "An error occurred while saving the user.";
      setApiError(error_Msg);
      console.error("Error saving user:", error);
    }

    setTimeout(() => {
      setApiError("");
    }, 5000)

    setLoader4UpdatingUser(false);
  };

  const generatePassword = () => {
      let charset = "";
      let newPassword = "";

      if (useSymbols) charset += "!@#$%^&*()";
      if (useNumbers) charset += "0123456789";
      if (useLowerCase) charset += "abcdefghijklmnopqrstuvwxyz";
      if (useUpperCase) charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

      for (let i = 0; i < passwordLength; i++) {
          newPassword += charset.charAt(Math.floor(Math.random() * charset.length));
      }      
      const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/;
      if(newPassword.match(regex)) {
        setFormData((prevState) => ({
          ...prevState,
          'password': newPassword,
          'confirm_password': newPassword,
        }));
      } else {
        generatePassword();
    }
  };

  const toggleShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <div className="chatbox-container">
      <div className="chatbox-header" onClick={onBack}>
        <img className="back-btn-img" src="/img/back_top.png" />
        <span className="back_chat_top cursorP">Back</span>
      </div>

      <div className="chatbox-messages-container add-user-form-container-sc  ">
        <div className="row">
          <div className="col-md-12">
            <div className="row mb-3">
              <div class="col-md-9">
                <h4 class="blue add_user_heading">Add User</h4>
              </div>
            </div>

            <div className="row" style={{'fontSize': '12px'}}>
              
              <div class="col-md-12">
                {apiError && <Alert type="danger" message={apiError} />}

                <Form
                  className="user_form_info"
                  autoComplete="off"
                >
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-control-info">
                        <Form.Label className="">
                          First name <span className='red'>*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="firstname"
                          className="form-input"
                          style={{ marginLeft: "5px" }}
                          value={formData.firstname}
                          onChange={handleChange}
                        ></Form.Control>
                        {errors.firstname && (
                            <div className="text-danger custom_error_msg pt-1 px-2">
                            {errors.firstname}
                            </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-control-info">
                        <Form.Label className="">
                          Last name <span className='red'>*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="lastname"
                          className="form-input"
                          style={{ marginLeft: "5px" }}
                          value={formData.lastname}
                          onChange={handleChange}
                        ></Form.Control>
                        {errors.lastname && (
                            <div className="text-danger custom_error_msg pt-1 px-2">
                            {errors.lastname}
                            </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-control-info">
                        <Form.Label className="">
                          Email <span className='red'>*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="email"
                          className="form-input"
                          style={{ marginLeft: "5px" }}
                          value={formData.email}
                          onChange={handleChange}
                        ></Form.Control>
                        {errors.email && (
                            <div className="text-danger custom_error_msg pt-1 px-2">
                            {errors.email}
                            </div>
                        )}
                      </div>
                    </div>

                    </div>

                    <div className="row">

                    <div className="col-md-6">
                      <div className="input-group form-control-info">
                        <Form.Label className="form-label custom_label custom_generate_label">
                            Password <span className='red'>*</span>
                            <Link className="generate_password" onClick={generatePassword}>
                            <span className="">Generate Password</span>
                            </Link>
                        </Form.Label>
                         <div className="input-group">
                        <Form.Control
                          type={showPassword ? 'text' : 'password'}
                          name="password"
                          className="form-input"
                          style={{ marginLeft: "5px" }}
                          value={formData.password}
                          onChange={handleChange}
                        ></Form.Control>
                        <div className="input-group-append" style={{'position': 'absolute', 'right': '8px', 'top': '3px', 'zIndex': '5'}}>
                        <span className="" onClick={toggleShowPassword} style={{ cursor: 'pointer' }}>
                          <i className={`fa fa-eye${ showPassword ? '' : '-slash' }`} aria-hidden="true"></i>
                        </span>
                      </div>
                      </div>

                        {edit_user_id && 
                        <span className='keep_blank_span'>
                            Keep blank if you don't want to change password
                        </span>
                        }

                        {errors.password && (
                        <div className="text-danger custom_error_msg pt-1 px-2">
                          {errors.password}
                        </div>
                      )}

                      </div>
                      
                      
                    </div>

                    <div className="col-md-6">
                      <div className="form-control-info">
                        <Form.Label className="">
                          Confirm Password <span className='red'>*</span>
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="confirm_password"
                          className="form-input"
                          style={{ marginLeft: "5px" }}
                          value={formData.confirm_password}
                          onChange={handleChange}
                        ></Form.Control>
                        {errors.confirm_password && (
                            <div className="text-danger custom_error_msg pt-1 px-2">
                            {errors.confirm_password}
                            </div>
                        )}
                      </div>
                    </div>
                    
                    <div className="col-md-6">
                      <div className="form-control-info">
                        <Form.Label className="">Title</Form.Label>
                        <Form.Control
                          type="text"
                          name="title"
                          className="form-input"
                          style={{ marginLeft: "5px" }}
                          value={formData.title}
                          onChange={handleChange}
                        ></Form.Control>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-control-info">
                        <Form.Label className="">
                          Department
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="designation"
                          className="form-input"
                          style={{ marginLeft: "5px" }}
                          value={formData.designation}
                          onChange={handleChange}
                        ></Form.Control>
                        {errors.designation && (
                            <div className="text-danger custom_error_msg pt-1 px-2">
                            {errors.designation}
                            </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                      <div className="form-control-info">
                        <Form.Label className="">
                          Country
                        </Form.Label>
                        <Form.Control
                          className="form-input font12"
                          as="select"
                          name="country"
                          style={{ paddingLeft: "15px", padding: "5px 10px" }}
                          value={formData.country}
                          onChange={handleChange}
                        >
                          <option key="" value="">
                            Select Country
                          </option>
                          {Object.keys(countryOptions).map((key) => (
                            <option key={`country-${key}`} value={key}>
                              {countryOptions[key]}
                            </option>
                          ))}
                        </Form.Control>
                        {errors.country && (
                            <div className="text-danger custom_error_msg pt-1 px-2">
                            {errors.country}
                            </div>
                        )}
                      </div>
                      
                    </div>

                    <div className='col-md-6'>
                        <label htmlFor="labelAccountStatus" className="form-label custom_label">Select Accounts</label>
                        <Multiselect
                            name="assigned_accounts"
                            // value={formData?.assigned_accounts || []}
                            options={account_list}
                            onSelect={handleChangeAccountsSelect}
                            onRemove={handleRemoveAccountsSelect}
                            displayValue="account_name"
                            selectedValues={selectedAssignedAccounts}
                            showCheckbox={true}
                            placeholder="Select Accounts"></Multiselect>
                            
                        {errors?.accounts && <div className="text-danger custom_error_msg">{errors.accounts}</div>}
                        
                    </div>
                    </div>
                    
                    <div className="row">
                      <div className="col-md-6"></div>

                    <div className="col-md-6"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6  pt-2">
                    <div className="prev_next_block pull-left">
                      <Button
                        variant="secondary"
                        type="button"
                        onClick={onBack}
                        className="btn bt-secondary mr-2 font12"
                      >
                        Cancel
                      </Button>
                      <Button type="button"
                        disabled={loader4UpdatingUser} variant="" onClick={handleSubmit}
                      className="profile_buttons  font12">

                        {loader4UpdatingUser ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : (
                        <></>
                      )}{" "}

                       {edit_user_id ? 'Update User' : 'Add User' }
                      </Button>
                    </div>
                  </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
